/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchQueryCreationData } from '../../models/search-query-creation-data';

export interface VaultCreateVaultSearchQuery$Params {

/**
 * GUID of the vault
 */
  vaultId: string;
  
    /**
     * Search query creation data
     */
    body?: SearchQueryCreationData
}

export function vaultCreateVaultSearchQuery(http: HttpClient, rootUrl: string, params: VaultCreateVaultSearchQuery$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, vaultCreateVaultSearchQuery.PATH, 'post');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

vaultCreateVaultSearchQuery.PATH = '/vault/{vaultId}/search-query';
